import React, { Component } from "react";
import { toast } from 'react-toastify'
import moment from "moment";
import CKEditor from "react-ckeditor-component";
import { v4 as uuid } from 'uuid';
import AdmissionApi from "../../../../Services/AdmissionApi";

class AdminScholarshipAlertForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      scholarshipName: "",
      sponsoringInstitution: "",
      minAmount: 0,
      maxAmount: 0,
      lastDate: moment().format('YYYY-MM-DD'),
      generalInformation: "",
      selectionProcess: "",
      eligibility: "",
      importantLinks: "",
      applyLink: "",
      keyDates: [
        {
          id: uuid(),
          activity: '',
          activity_date: moment().format('YYYY-MM-DD')
        }
      ],
      errors: {
        scholarshipName: '',
        sponsoringInstitution: '',
        minAmount: '',
        maxAmount: '',
        lastDate: '',
        generalInformation: '',
        selectionProcess: '',
        eligibility: '',
        importantLinks: '',
        applyLink: "",
        keyDates: {}
      },
    }

    this.admissionsService = new AdmissionApi();
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      const keyDates = data.key_dates.map(item => ({
        id: uuid(),
        activity: item.activity,
        activity_date: moment(item.activity_date).format('YYYY-MM-DD')
      }))

      this.setState({
        id: data.id,
        scholarshipName: data.name,
        sponsoringInstitution: data.sponsoring_institution,
        minAmount: data.amount_from,
        maxAmount: data.amount_to,
        lastDate: moment(data.scholarship_last_date).format('YYYY-MM-DD'),
        generalInformation: data.general_information,
        selectionProcess: data.selection_process,
        eligibility: data.eligibilty,
        importantLinks: data.important_link,
        applyLink: data.apply_link,
        keyDates,
      })
    }
  }

  updateState = newResponse => {
    if (newResponse.data.success) {
      this.props.updateRoutePage('scholarship-alerts')
    } else {
      let errors = {};
      console.log(newResponse.data.messages.body);
    }
  }

  handleValidation = () => {
    let fields = this.state
    let formIsValid = true
    let errors = {
      scholarshipName: '',
      sponsoringInstitution: '',
      minAmount: '',
      maxAmount: '',
      lastDate: '',
      generalInformation: '',
      selectionProcess: '',
      eligibility: '',
      applyLink: '',
      keyDates: {}
    }

    //name
    if (!fields["scholarshipName"]) {
      formIsValid = false;
      errors["scholarshipName"] = "Cannot be empty";
    }

    //sponsoring_institution
    if (!fields["sponsoringInstitution"]) {
      formIsValid = false;
      errors["sponsoringInstitution"] = "Cannot be empty";
    }

    // min amount
    if (!fields["minAmount"]) {
      formIsValid = false;
      errors["minAmount"] = "Cannot be empty";
    }

    //scholarship_last_date
    if (!fields["lastDate"]) {
      formIsValid = false;
      errors["lastDate"] = "Cannot be empty";
    }

    if (!fields["generalInformation"]) {
      formIsValid = false;
      errors["generalInformation"] = "Cannot be empty";
    }

    if (!fields["selectionProcess"]) {
      formIsValid = false;
      errors["selectionProcess"] = "Cannot be empty";
    }

    if (!fields["eligibility"]) {
      formIsValid = false;
      errors["eligibility"] = "Cannot be empty";
    }

    fields['keyDates'].forEach((item) => {
      if (!item.activity) {
        formIsValid = false
        errors.keyDates[item.id] = 'Cannot be empty'
      }
    })

    errors["responseError"] = "";

    this.setState({ errors });
    return formIsValid;
  }

  onSubmit() {
    if (!this.handleValidation()) return

    const {
      id,
      scholarshipName,
      sponsoringInstitution,
      minAmount,
      maxAmount,
      lastDate,
      generalInformation,
      selectionProcess,
      eligibility,
      importantLinks,
      applyLink,
      keyDates,
    } = this.state

    let obj = {
      name: scholarshipName,
      sponsoring_institution: sponsoringInstitution,
      amount: maxAmount ? `${minAmount}-${maxAmount}` : minAmount,
      amount_from: minAmount,
      amount_to: maxAmount || 0,
      scholarship_last_date: lastDate,
      general_information: generalInformation,
      selection_process: selectionProcess,
      eligibilty: eligibility,
      important_link: importantLinks,
      apply_link: applyLink,
      key_dates: keyDates
    }

    if (id) obj['id'] = id

    if (!id) {
      this.admissionsService.createNew(
        res => {
          if(res.status === 200) {
            toast.success(("Scholarship added successfully."))
            this.updateState()
          }
        },
        obj,
        "v1/alerts/scholarships"
      );
    } else {
      this.admissionsService.updateCredentials(
        res => {
          if(res.status === 200) {
            toast.success(("Scholarship updated successfully."))
            this.updateState()
          }
        },
        obj,
        "v1/alerts/scholarships"
      );
    }
  }

  resetErrorMsg = (errorId, isKeyDate = false) => {
    if (isKeyDate) {
      this.setState((preState) => ({
        errors: {
          ...preState.errors,
          keyDates: {
            ...preState.errors.keyDates,
            [errorId]: ''
          }
        }
      }))
    } else {
      this.setState((preState) => ({
        errors: { ...preState.errors, [errorId]: "" },
      }))
    }
  }

  handleFormFieldChange = (e) => {
    e.preventDefault()
    const { value, id, name } = e.target

    switch (name) {
      case 'activity':
        this.setState((prevState) => ({
          keyDates: prevState.keyDates.map((item) => {
            return item.id === id
              ? {
                ...item,
                activity: value
              }
              : item
          })
        }))
        break;
      case 'activity_date':
        this.setState((prevState) => ({
          keyDates: prevState.keyDates.map((item) => {
            return item.id === id
              ? {
                ...item,
                activity_date: value
              }
              : item
          })
        }))
        break;
      default:
        this.setState({
          [id]: value
        })
    }

    if (name === 'activity') {
      this.resetErrorMsg(id, true)
    } else {
      this.resetErrorMsg(id)
    }

  }

  handleEditorChange = (evt, id) => {
    var newContent = evt.editor.getData();
    this.setState({ [id]: newContent });
    this.resetErrorMsg(id)
  }

  addKeyEvent = () => {
    this.setState((prevState) => ({
      keyDates: [
        ...prevState.keyDates,
        {
          id: uuid(),
          activity: '',
          activity_date: moment().format('YYYY-MM-DD')
        }
      ]
    }))
  }

  removeKeyEvent = (id) => {
    this.setState((prevState) => ({
      keyDates: prevState.keyDates.filter(item => item.id !== id)
    }))
  }

  render() {
    const {
      scholarshipName,
      sponsoringInstitution,
      minAmount,
      maxAmount,
      lastDate,
      generalInformation,
      selectionProcess,
      eligibility,
      importantLinks,
      applyLink,
      keyDates,
      errors
    } = this.state

    const { updateRoutePage } = this.props

    return (
      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["scholarshipName"] && 'm-0'}`}>
            <label>Scholarship Name</label>
            <input
              type="text"
              id="scholarshipName"
              className="form-control alert-filter__input"
              placeholder="Scholarship Name"
              value={scholarshipName}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["scholarshipName"]}
          </span>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["sponsoringInstitution"] && 'm-0'}`}>
            <label>Sponsoring Institution</label>
            <input
              type="text"
              id="sponsoringInstitution"
              className="form-control alert-filter__input"
              placeholder="Sponsoring Institution"
              value={sponsoringInstitution}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["sponsoringInstitution"]}
          </span>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["minAmount"] && 'm-0'}`}>
            <label>Amount From</label>
            <input
              type="number"
              id="minAmount"
              className="form-control alert-filter__input"
              min="0"
              placeholder="0"
              value={minAmount}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["minAmount"]}
          </span>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["maxAmount"] && 'm-0'}`}>
            <label>Amount To</label>
            <input
              type="number"
              id="maxAmount"
              className="form-control alert-filter__input"
              min="0"
              placeholder="9999"
              value={maxAmount}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["maxAmount"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["lastDate"] && 'm-0'}`}>
            <label>Last Date to Apply</label>
            <input
              type="date"
              id="lastDate"
              className="form-control alert-filter__input"
              value={lastDate}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["lastDate"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["generalInformation"] && 'm-0'}`}>
            <label>General Information</label>
            <CKEditor
              content={generalInformation}
              events={{
                change: (e) => this.handleEditorChange(e, 'generalInformation')
              }}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["generalInformation"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["selectionProcess"] && 'm-0'}`}>
            <label>Selection Process</label>
            <CKEditor
              content={selectionProcess}
              events={{
                change: (e) => this.handleEditorChange(e, 'selectionProcess')
              }}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["selectionProcess"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["eligibility"] && 'm-0'}`}>
            <label>Eligibility</label>
            <CKEditor
              content={eligibility}
              events={{
                change: (e) => this.handleEditorChange(e, 'eligibility')
              }}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["eligibility"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className="form-group">
            <label>Important Links</label>
            <CKEditor
              content={importantLinks}
              events={{
                change: (e) => this.handleEditorChange(e, 'importantLinks')
              }}
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["applyLink"] && 'm-0'}`}>
            <label>Apply Link</label>
            <input
              type="text"
              id="applyLink"
              className="form-control alert-filter__input"
              placeholder="Apply Link"
              value={applyLink}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["applyLink"]}
          </span>
        </div>
        <div className="col-12">
          <div className="row">
            {keyDates.map(item => (
              <React.Fragment key={item.id}>
                <div className="col-sm-12 col-lg-6">
                  <div className={`form-group ${errors.keyDates[item.id] && 'm-0'}`}>
                    <label>Key Event</label>
                    <input
                      type="text"
                      className="form-control alert-filter__input"
                      name="activity"
                      id={item.id}
                      value={item.activity}
                      onChange={this.handleFormFieldChange}
                      placeholder="Event"
                    />
                  </div>
                  <span style={{ color: "red", fontFamily: "italian" }}>
                    {errors.keyDates[item.id]}
                  </span>
                </div>
                <div className="col-sm-12 col-lg-4">
                  <div className="form-group">
                    <label>Date</label>
                    <input
                      type="date"
                      className="form-control alert-filter__input"
                      name="activity_date"
                      id={item.id}
                      value={item.activity_date}
                      onChange={this.handleFormFieldChange}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-lg-2">
                  <button className="btn btn-link key-event-remove" style={{ marginTop: 22 }} onClick={() => this.removeKeyEvent(item.id)}>Remove</button>
                </div>
              </ React.Fragment>
            ))}
            <div className="col-sm-12">
              <button className="btn btn-link w-100 text-center" onClick={this.addKeyEvent}>+ Add Key Event</button>
            </div>
          </div>
        </div>
        <div className="col-12 text-right my-3">
          <button
            onClick={() => updateRoutePage('scholarship-alerts')}
            className="btn btn-link"
          >
            Cancel
          </button>
          <button
            onClick={() => this.onSubmit()}
            className="btn btn--primary ml-2"
          >
            Submit
          </button>
        </div>
      </div>
    )
  }
}

export default AdminScholarshipAlertForm



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminScholarshipAlerts/AdminScholarshipAlertForm/index.js
 **/